import { X, Search, MessageSquare } from 'lucide-react';

interface FollowUpModeSelectorProps {
  onPickLead: () => void;
  onGeneralAdvice: () => void;
  onClose: () => void;
}

export function FollowUpModeSelector({ onPickLead, onGeneralAdvice, onClose }: FollowUpModeSelectorProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden border border-gray-200">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#05E0D1]/5 to-[#1875FF]/5">
          <div>
            <h3 className="text-lg font-extrabold text-gray-900 font-display">Follow Up Strategy</h3>
            <p className="text-sm text-gray-500 mt-0.5">How would you like to get started?</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        <div className="p-5 space-y-3">
          <button
            onClick={onPickLead}
            className="w-full flex items-center gap-4 p-4 rounded-xl border-2 border-gray-100 hover:border-[#1875FF]/40 hover:bg-[#1875FF]/5 transition-all text-left group"
          >
            <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-[#1875FF]/10 to-[#05E0D1]/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <Search size={22} className="text-[#1875FF]" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-bold text-gray-900 text-sm">Pick a Specific Lead</h4>
              <p className="text-xs text-gray-500 mt-0.5">Get personalized follow-up coaching based on a lead's engagement history</p>
            </div>
          </button>

          <button
            onClick={onGeneralAdvice}
            className="w-full flex items-center gap-4 p-4 rounded-xl border-2 border-gray-100 hover:border-[#05E0D1]/40 hover:bg-[#05E0D1]/5 transition-all text-left group"
          >
            <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#05E0D1]/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <MessageSquare size={22} className="text-[#05E0D1]" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-bold text-gray-900 text-sm">General Follow Up Advice</h4>
              <p className="text-xs text-gray-500 mt-0.5">Get general coaching on follow-up strategy, timing, and messaging</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
